import { render, staticRenderFns } from "./capital.vue?vue&type=template&id=6e5db941&scoped=true"
import script from "./capital.vue?vue&type=script&lang=js"
export * from "./capital.vue?vue&type=script&lang=js"
import style0 from "./capital.vue?vue&type=style&index=0&id=6e5db941&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5db941",
  null
  
)

export default component.exports